
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/contexts/auth";
import { useSubscription } from "@/pages/pricing/hooks/useSubscription";
import { useEffect } from "react";

export function DashboardHeader() {
  const { profile, refreshProfile } = useAuth();
  const { isSubscribed, refreshSubscription } = useSubscription();
  
  // Force refresh on mount to get latest data
  useEffect(() => {
    const forceRefresh = async () => {
      console.log('=== DASHBOARD HEADER REFRESH ===');
      console.log('Initial isSubscribed state:', isSubscribed);
      console.log('Initial profile:', profile);
      
      // Refresh profile first
      console.log('Refreshing profile...');
      await refreshProfile();
      
      // Then refresh subscription with force flag
      if (refreshSubscription) {
        console.log('Refreshing subscription with force flag...');
        const result = await refreshSubscription(true);
        console.log('Subscription refresh result:', result);
      }
      
      console.log('=== REFRESH COMPLETED ===');
      console.log('Final isSubscribed:', isSubscribed);
      console.log('Final profile tier:', profile?.subscription_tier);
    };
    
    forceRefresh();
  }, []); // Empty dependency array to run only once on mount
  
  return (
    <div className="flex justify-between items-center">
      <div>
        <div className="flex items-center gap-3">
          <h1 className="text-3xl font-bold">Your Dashboard</h1>
          {isSubscribed ? (
            <Badge className="bg-green-500/10 text-green-500 border-green-500/20">
              Pro
            </Badge>
          ) : (
            <Badge variant="outline">
              Free
            </Badge>
          )}
        </div>
        {profile && <p className="text-muted-foreground">Welcome, {profile.full_name || 'User'}</p>}
      </div>
    </div>
  );
}
